/* eslint-env browser */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-router';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';

import { loadEvent, apiFetch, API_ROOT, setFlashMessage, removeFlashMessage, markInboxChangeApproved } from 'actions';
import Loading from 'components/common/Loading';

class ActionButtonRow extends Component {
  render() {
    const { change, includeReason } = this.props;
    let { actions, onConflicts } = this.props;
    let reason;

    onConflicts = onConflicts || Function.prototype;

    if (change && change.change_actions) {
      actions = change.change_actions;
    } else if (change && change.change_action) {
      actions = change.change_action;
    }

    if (isEmpty(actions)) {
      return null;
    }

    const handleConflictReasonChange = (event) => {
      reason = event.target.value;
    };

    const doClickAction = (actionHref, event, action) => {
      const eventIdOffsetString = 'type=view&action=event&id=';
      const indexEventId = actionHref.indexOf(eventIdOffsetString);
      let href = actionHref;

      if (href.indexOf('json=t') !== -1) {
        const target = event.currentTarget;
        if (!target.classList.contains('loading')) {
          target.classList.add('loading');

          if (reason) {
            href += `&reason=${encodeURIComponent(reason)}`;
          }

          apiFetch(`${API_ROOT}?${href}`, true).then((response) => {
            if (response.result === true) {
              if (change && this.props.event.changes && this.props.event.changes.length > 1) {
                target.classList.remove('loading');
                setTimeout(() => {
                  this.props.markInboxChangeApproved(this.props.event.id, change.change_id, change.change_set_id);
                }, 400);
              } else {
                let message = 'Action was accepted';
                if (has(response, 'rule_action_data.data')) {
                  message = response.rule_action_data.data;
                }
                message = `Success: ${message}`;
                this.props.setFlashMessage(message);

                // Give it a second to set in that we finished performing the action
                // and then redirect to main inbox page
                setTimeout(() => {
                  target.classList.remove('loading');
                  if (this.props.pathname.indexOf('/calendar') === 0) {
                    if (has(this.props, 'event.id')) {
                      this.props.loadEvent(this.props.event.id);
                    } else {
                      this.props.push('/calendar');
                    }
                  } else {
                    this.props.push('/inbox');
                  }
                }, 1000);

                // Clear the flashMessage after some ammount of time the 'feels right' (4500ms)
                setTimeout(() => {
                  this.props.removeFlashMessage(message);
                }, 4500);
              }
            } else if (response.has_conflicts === true) {
              onConflicts(response);
              // this.setState({conflicts: response});
              target.classList.remove('loading');
            }
          }, () => {
            target.classList.remove('loading');
          });
        }
      } else if (indexEventId !== -1) {
        const eventId = href.replace(eventIdOffsetString, '');
        this.props.push(`/calendar/details/${eventId}`);
      }
    };

    return (
      <div>
        {includeReason && (
          <span>
            <h4>Comments/Reasons</h4>
            <textarea className="conflict-reason" onChange={handleConflictReasonChange} />
          </span>
        )}

        <section className="button-row">
          {actions.map((action, index) => {
            const handleClick = (clickAction, event) => {
              let href = clickAction.href.replace(/&amp;/g, '&').replace('index.php?', '');
              const httpsIndex = href.indexOf('https://');
              if (httpsIndex !== -1) {
                href = href.substring( href.indexOf('?') + 1 );
              }
              if (href === 'EDIT_EVENT') {
                this.props.push(`/calendar/edit/${this.props.event.id}`);
                return;
              }

              if (action.display_type === 'decline' || action.display_type === 'attention') {
                /* eslint no-alert: 0 */
                if (confirm('Are you sure you want to ' + action.text + '?')) {
                  doClickAction(href, event, action);
                }
              } else {
                doClickAction(href, event, action);
              }
            };
            return (
              <button
                onClick={(event) => { handleClick(action, event); }}
                className={action.display_type}
                key={`${this.props.event.id}_${action.text}_${index}`}
                style={{ position: 'relative' }}
              >
                <Loading
                  className="button-loading"
                  size="small"
                  color="white"
                  style={{
                    position: 'absolute',
                    top: 9,
                    left: 6,
                  }}
                />
                {action.text}
              </button>
            );
          })}
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { router } = state;
  const { pathname } = router.location;

  return {
    pathname,
    // events,
  };
}

export default connect(mapStateToProps, {
  setFlashMessage,
  removeFlashMessage,
  push,
  markInboxChangeApproved,
  loadEvent,
})(ActionButtonRow);



// WEBPACK FOOTER //
// ./src/app/components/inbox/ActionButtonRow.js